<template>
  <div class="demo-container">

    <div style="font-size:18px;font-weight:500;text-align:center; margin-top:20px">
      防篡改鉴别
    </div>

    <div v-if="!success" style="width:100%;display:flex;justify-content: center;flex-direction: column;align-items: center;margin:30px 0">
      <div style="width:62px;height:62px">
        <img style="width:62px" src="https://oss.turingsenseai.com/1641810958950336609.png" alt="">
      </div>
      <span style="font-weight:500;font-size:18px">
        图灵鉴定
      </span>
    </div>

    <div v-if="success" style="width:100%;display:flex;justify-content: center;flex-direction: column;align-items: center;margin:30px 0">
      <span style="font-weight:500;font-size:18px">
        鉴别结论
      </span>
      <br>
      <div style="margin: 0 30px; font-size: 14px">
        {{data.description}}
      </div>
    </div>

    <div class="pic-stage" @click="preview">
      <div :style="{background: `no-repeat center/contain url(${imgUrl})`, width: '230px', height: '230px'}"></div>
      <img v-if="!imgUrl" src="https://oss.turingsenseai.com/1641966776959081286.png" alt="">
    </div>

    <div v-if="takePhoto && !success" class="btn-wrapper">
      <div>
        <div class="btn " @click="uploadAgain">重新上传</div>
        <div class="btn gradient bubbly-button h-button" @click="submit" ref="sub">提交</div>
      </div>
    </div>

    <div v-if="!takePhoto" class="icon-btn">
      <van-uploader :after-read="afterRead" />
      <span class="txt">上传</span>
    </div>  

    <div v-if="success" class="btn back" @click="back">返回</div>

  </div>
</template>

<script>
import { Toast, ImagePreview, Overlay } from 'vant';
import axios from 'axios';
import {uploadImage} from '../../common/api/common';

Toast.setDefaultOptions({ duration: 1000000 });
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Overlay.Component.name]: Overlay.Component,
  },
  data(){
    return {
      takePhoto: false,
      success: false,
      loading: false,
      imgUrl: null,
      data: {}
    }
  },
  methods: {
    uploadAgain(){
      this.takePhoto = false
      this.imgUrl = null
    },
    async afterRead(file){
      console.log(file);
      const instance = Toast.loading({
        message: '上传中...',
        forbidClick: true,
        onOpened: async () => {
          const res = await uploadImage({imgB64: file.content.split(',')[1]});
          if(res.errorMsg === 'Success'){
            this.imgUrl = res.imageUrl
            this.takePhoto = true
          }
          instance.clear();
        }
      });
      
    },
    preview(){
      if(this.imgUrl){
        ImagePreview({
          images: [
            this.imgUrl
          ],
          closeable: true,
        });
      }

    },
    async submit(e){
      const instance = Toast.loading({
        message: '鉴别中...',
        forbidClick: true,
        onOpened: async () => {
          const res = await axios.post('http://114.113.235.71:5000/api/authentication', {image_url: this.imgUrl});
          console.log(res);
          if(res.data && res.data.img_base64){
            this.data = res.data;
            this.imgUrl = 'data:image/jpeg;base64,' + res.data.img_base64
            this.success = true;
          }else{
            Toast({
              message: res.data.err_msg,
              duration: 3000
            });
          }
          instance.clear();
        }
      });
    },
    back(){
      this.takePhoto = false
      this.success = false;
      this.imgUrl = null 
    }
  }
}
</script>

<style lang="scss">
.demo-container{
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: absolute;
}  


.btn-wrapper > div{
  display: flex;
  justify-content: center;
  margin-top: 100px;
}


.btn{
  width: 320px;
  height: 96px;
  border-radius: 200px;
  background: #EFEFF4;
  color: #3A3D44;
  text-align: center;
  line-height: 96px;
  font-weight: 500;
  font-size: 34px;
}

.back {
  margin: 0 auto;
  margin-top: 100px;
}

.pic-stage{
  height: 460px;
  width: 460px;
  border-radius: 24px;
  background: #F5F6FA;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 80px;
    height: 80px;
    position: absolute;
  }
}

.txt{
  color: #3A3D44;
  font-weight: 500;
}

.gradient {
  background: linear-gradient(270deg, #3A94FF 0%, #74C8F5 100%);
  font-style: normal;
  color: #fff;
  margin-left: 20px;
}

.icon-btn{
  display: flex;
  flex-direction: column;
  margin-top: 100px;
  align-items: center;
  position: relative;
  
  .txt{
    margin-top: 15px;
  }


  .van-uploader{
    .van-uploader__wrapper{
      .van-uploader__upload{
        .van-icon-photograph::before{
          content: "";
          background: no-repeat center/contain url(https://oss.turingsenseai.com/1641812306255974240.png);
          width: 54px;
          height: 54px;
        }
        background: #fff;
        width: 96px;
        height: 96px;
        margin: unset;
        border-radius: 200px;
        box-shadow: 0px 4px 20px 0px #00000029;
      }
    }
  }
}

</style>